/** @jsx jsx */
import { jsx } from '@emotion/react';
import { animated } from 'react-spring';
import ouiStyle from '@goldwasserexchange/oui-style';
import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import { Link } from './link';
export var DomAContainerBase = function (props) {
    var href = props.href, target = props.target, rel = props.rel, cssStyle = props.cssStyle, onClick = props.onClick, animatedValues = props.animatedValues, children = props.children;
    return animatedValues === undefined
        ? (jsx("a", { css: ouiStyle.mediaQuery(cssStyle), href: typeof href === 'function' ? href() : href, target: target, rel: rel, onClick: onClick }, children))
        : (jsx(animated.a, { css: ouiStyle.mediaQuery(cssStyle), href: typeof href === 'function' ? href() : href, target: target, rel: rel, onClick: onClick, style: animatedValues }, children));
};
export var DomAContainer = function (props) {
    var href = props.href, target = props.target, rel = props.rel, display = props.display, flexDirection = props.flexDirection, alignItems = props.alignItems, alignSelf = props.alignSelf, justifyContent = props.justifyContent, position = props.position, flexGrow = props.flexGrow, flexShrink = props.flexShrink, flexBasis = props.flexBasis, whiteSpace = props.whiteSpace, lines = props.lines, minus = props.minus, widthLines = props.widthLines, minusWidth = props.minusWidth, textAlign = props.textAlign, textOverflow = props.textOverflow, textTransform = props.textTransform, textDecoration = props.textDecoration, fontSize = props.fontSize, lineFactor = props.lineFactor, fontWeight = props.fontWeight, fontStyle = props.fontStyle, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, color = props.color, minLines = props.minLines, minIcon = props.minIcon, minFontSize = props.minFontSize, minPaddingTop = props.minPaddingTop, minPaddingBottom = props.minPaddingBottom, minChildPaddingTop = props.minChildPaddingTop, minChildPaddingBottom = props.minChildPaddingBottom, minParentBorderTopWidth = props.minParentBorderTopWidth, minParentBorderBottomWidth = props.minParentBorderBottomWidth, transformOrigin = props.transformOrigin, zIndex = props.zIndex, flex = props.flex, overflow = props.overflow, onClick = props.onClick, animatedValues = props.animatedValues, children = props.children;
    var css = ouiStyle.useACss({
        display: display,
        flexDirection: flexDirection,
        alignItems: alignItems,
        alignSelf: alignSelf,
        justifyContent: justifyContent,
        position: position,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flexBasis: flexBasis,
        whiteSpace: whiteSpace,
        lines: lines,
        minus: minus,
        widthLines: widthLines,
        minusWidth: minusWidth,
        textAlign: textAlign,
        textTransform: textTransform,
        textDecoration: textDecoration,
        textOverflow: textOverflow,
        fontSize: fontSize,
        fontStyle: fontStyle,
        lineFactor: lineFactor,
        fontWeight: fontWeight,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        color: color,
        minLines: minLines,
        minIcon: minIcon,
        minFontSize: minFontSize,
        minPaddingTop: minPaddingTop,
        minPaddingBottom: minPaddingBottom,
        minChildPaddingTop: minChildPaddingTop,
        minChildPaddingBottom: minChildPaddingBottom,
        minParentBorderTopWidth: minParentBorderTopWidth,
        minParentBorderBottomWidth: minParentBorderBottomWidth,
        transformOrigin: transformOrigin,
        zIndex: zIndex,
        flex: flex,
        overflow: overflow,
    });
    return (jsx(DomAContainerBase, { href: href, target: target, rel: rel, cssStyle: css, onClick: onClick, animatedValues: animatedValues }, children));
};
export var DomLinkContainer = function (props) {
    var to = props.to, replace = props.replace, target = props.target, rel = props.rel, display = props.display, flexDirection = props.flexDirection, alignItems = props.alignItems, alignSelf = props.alignSelf, justifyContent = props.justifyContent, position = props.position, flexGrow = props.flexGrow, flexShrink = props.flexShrink, flexBasis = props.flexBasis, whiteSpace = props.whiteSpace, lines = props.lines, minus = props.minus, widthLines = props.widthLines, minusWidth = props.minusWidth, textAlign = props.textAlign, textTransform = props.textTransform, textDecoration = props.textDecoration, textOverflow = props.textOverflow, fontSize = props.fontSize, lineFactor = props.lineFactor, fontWeight = props.fontWeight, fontStyle = props.fontStyle, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, color = props.color, minLines = props.minLines, minIcon = props.minIcon, minFontSize = props.minFontSize, minPaddingTop = props.minPaddingTop, minPaddingBottom = props.minPaddingBottom, minChildPaddingTop = props.minChildPaddingTop, minChildPaddingBottom = props.minChildPaddingBottom, minParentBorderTopWidth = props.minParentBorderTopWidth, minParentBorderBottomWidth = props.minParentBorderBottomWidth, transformOrigin = props.transformOrigin, zIndex = props.zIndex, flex = props.flex, overflow = props.overflow, onClick = props.onClick, animatedValues = props.animatedValues, children = props.children;
    var css = ouiStyle.useACss({
        display: display,
        flexDirection: flexDirection,
        alignItems: alignItems,
        alignSelf: alignSelf,
        justifyContent: justifyContent,
        position: position,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        flexBasis: flexBasis,
        whiteSpace: whiteSpace,
        lines: lines,
        minus: minus,
        widthLines: widthLines,
        minusWidth: minusWidth,
        textAlign: textAlign,
        textTransform: textTransform,
        textDecoration: textDecoration,
        textOverflow: textOverflow,
        fontSize: fontSize,
        lineFactor: lineFactor,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        color: color,
        minLines: minLines,
        minIcon: minIcon,
        minFontSize: minFontSize,
        minPaddingTop: minPaddingTop,
        minPaddingBottom: minPaddingBottom,
        minChildPaddingTop: minChildPaddingTop,
        minChildPaddingBottom: minChildPaddingBottom,
        minParentBorderTopWidth: minParentBorderTopWidth,
        minParentBorderBottomWidth: minParentBorderBottomWidth,
        transformOrigin: transformOrigin,
        zIndex: zIndex,
        flex: flex,
        overflow: overflow,
    });
    return (jsx(Link, { href: to, replace: replace, target: target, rel: rel, animatedValues: animatedValues, css: ouiStyle.mediaQuery(css), onClick: onClick }, children));
};
export var DomAButtonContainer = function (props) {
    var href = props.href, target = props.target, rel = props.rel, children = props.children, fontSize = props.fontSize, fontWeight = props.fontWeight, color = props.color, backgroundColor = props.backgroundColor, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, margin = props.margin, marginHorizontal = props.marginHorizontal, marginVertical = props.marginVertical, marginTop = props.marginTop, marginRight = props.marginRight, marginBottom = props.marginBottom, marginLeft = props.marginLeft, borderStyle = props.borderStyle, borderHorizontalStyle = props.borderHorizontalStyle, borderVerticalStyle = props.borderVerticalStyle, borderTopStyle = props.borderTopStyle, borderLeftStyle = props.borderLeftStyle, borderBottomStyle = props.borderBottomStyle, borderRightStyle = props.borderRightStyle, borderWidth = props.borderWidth, borderHorizontalWidth = props.borderHorizontalWidth, borderVerticalWidth = props.borderVerticalWidth, borderTopWidth = props.borderTopWidth, borderLeftWidth = props.borderLeftWidth, borderBottomWidth = props.borderBottomWidth, borderRightWidth = props.borderRightWidth, borderColor = props.borderColor, borderHorizontalColor = props.borderHorizontalColor, borderVerticalColor = props.borderVerticalColor, borderTopColor = props.borderTopColor, borderLeftColor = props.borderLeftColor, borderBottomColor = props.borderBottomColor, borderRightColor = props.borderRightColor, parentBorderTopWidth = props.parentBorderTopWidth, parentBorderLeftWidth = props.parentBorderLeftWidth, parentBorderBottomWidth = props.parentBorderBottomWidth, parentBorderRightWidth = props.parentBorderRightWidth, parentBorderTopStyle = props.parentBorderTopStyle, parentBorderLeftStyle = props.parentBorderLeftStyle, parentBorderBottomStyle = props.parentBorderBottomStyle, parentBorderRightStyle = props.parentBorderRightStyle, parentBorderTopColor = props.parentBorderTopColor, parentBorderLeftColor = props.parentBorderLeftColor, parentBorderBottomColor = props.parentBorderBottomColor, parentBorderRightColor = props.parentBorderRightColor, borderRadius = props.borderRadius, borderLeftBeforeTopRadius = props.borderLeftBeforeTopRadius, borderRightBeforeTopRadius = props.borderRightBeforeTopRadius, borderLeftBeforeBottomRadius = props.borderLeftBeforeBottomRadius, borderRightBeforeBottomRadius = props.borderRightBeforeBottomRadius, borderTopRadius = props.borderTopRadius, borderRightRadius = props.borderRightRadius, borderBottomRadius = props.borderBottomRadius, borderLeftRadius = props.borderLeftRadius, borderTopLeftRadius = props.borderTopLeftRadius, borderTopRightRadius = props.borderTopRightRadius, borderBottomRightRadius = props.borderBottomRightRadius, borderBottomLeftRadius = props.borderBottomLeftRadius, borderCollapse = props.borderCollapse, borderSpacing = props.borderSpacing, hoverBackgroundColor = props.hoverBackgroundColor, onClick = props.onClick, animatedValues = props.animatedValues, flexBasis = props.flexBasis, flexGrow = props.flexGrow, flexShrink = props.flexShrink, lineFactor = props.lineFactor, widthLines = props.widthLines;
    var css = ouiStyle.useButtonStyle({
        fontSize: fontSize,
        fontWeight: fontWeight,
        color: color,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        margin: margin,
        marginHorizontal: marginHorizontal,
        marginVertical: marginVertical,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        borderStyle: borderStyle,
        borderHorizontalStyle: borderHorizontalStyle,
        borderVerticalStyle: borderVerticalStyle,
        borderTopStyle: borderTopStyle,
        borderLeftStyle: borderLeftStyle,
        borderBottomStyle: borderBottomStyle,
        borderRightStyle: borderRightStyle,
        borderWidth: borderWidth,
        borderHorizontalWidth: borderHorizontalWidth,
        borderVerticalWidth: borderVerticalWidth,
        borderTopWidth: borderTopWidth,
        borderLeftWidth: borderLeftWidth,
        borderBottomWidth: borderBottomWidth,
        borderRightWidth: borderRightWidth,
        borderColor: borderColor,
        borderHorizontalColor: borderHorizontalColor,
        borderVerticalColor: borderVerticalColor,
        borderTopColor: borderTopColor,
        borderLeftColor: borderLeftColor,
        borderBottomColor: borderBottomColor,
        borderRightColor: borderRightColor,
        parentBorderTopWidth: parentBorderTopWidth,
        parentBorderLeftWidth: parentBorderLeftWidth,
        parentBorderBottomWidth: parentBorderBottomWidth,
        parentBorderRightWidth: parentBorderRightWidth,
        parentBorderTopStyle: parentBorderTopStyle,
        parentBorderLeftStyle: parentBorderLeftStyle,
        parentBorderBottomStyle: parentBorderBottomStyle,
        parentBorderRightStyle: parentBorderRightStyle,
        parentBorderTopColor: parentBorderTopColor,
        parentBorderLeftColor: parentBorderLeftColor,
        parentBorderBottomColor: parentBorderBottomColor,
        parentBorderRightColor: parentBorderRightColor,
        borderRadius: borderRadius,
        borderLeftBeforeTopRadius: borderLeftBeforeTopRadius,
        borderRightBeforeTopRadius: borderRightBeforeTopRadius,
        borderLeftBeforeBottomRadius: borderLeftBeforeBottomRadius,
        borderRightBeforeBottomRadius: borderRightBeforeBottomRadius,
        borderTopRadius: borderTopRadius,
        borderRightRadius: borderRightRadius,
        borderBottomRadius: borderBottomRadius,
        borderLeftRadius: borderLeftRadius,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderCollapse: borderCollapse,
        borderSpacing: borderSpacing,
        hoverBackgroundColor: hoverBackgroundColor,
        flexBasis: flexBasis,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        lineFactor: lineFactor,
        widthLines: widthLines,
    });
    return (jsx(DomAContainerBase, { href: href, target: target, rel: rel, cssStyle: css, onClick: onClick, animatedValues: animatedValues },
        children,
        jsx(RampWithNameTransform, { rampName: "RippleEffect", sourceBackgroundColor: css.backgroundColor })));
};
export var DomButtonLinkContainer = function (props) {
    var to = props.to, replace = props.replace, target = props.target, rel = props.rel, fontSize = props.fontSize, fontWeight = props.fontWeight, color = props.color, backgroundColor = props.backgroundColor, padding = props.padding, paddingHorizontal = props.paddingHorizontal, paddingVertical = props.paddingVertical, paddingTop = props.paddingTop, paddingLeft = props.paddingLeft, paddingBottom = props.paddingBottom, paddingRight = props.paddingRight, iconContainer = props.iconContainer, baselinePadding = props.baselinePadding, childPaddingTop = props.childPaddingTop, childPaddingLeft = props.childPaddingLeft, childPaddingBottom = props.childPaddingBottom, childPaddingRight = props.childPaddingRight, margin = props.margin, marginHorizontal = props.marginHorizontal, marginVertical = props.marginVertical, marginTop = props.marginTop, marginRight = props.marginRight, marginBottom = props.marginBottom, marginLeft = props.marginLeft, borderStyle = props.borderStyle, borderHorizontalStyle = props.borderHorizontalStyle, borderVerticalStyle = props.borderVerticalStyle, borderTopStyle = props.borderTopStyle, borderLeftStyle = props.borderLeftStyle, borderBottomStyle = props.borderBottomStyle, borderRightStyle = props.borderRightStyle, borderWidth = props.borderWidth, borderHorizontalWidth = props.borderHorizontalWidth, borderVerticalWidth = props.borderVerticalWidth, borderTopWidth = props.borderTopWidth, borderLeftWidth = props.borderLeftWidth, borderBottomWidth = props.borderBottomWidth, borderRightWidth = props.borderRightWidth, borderColor = props.borderColor, borderHorizontalColor = props.borderHorizontalColor, borderVerticalColor = props.borderVerticalColor, borderTopColor = props.borderTopColor, borderLeftColor = props.borderLeftColor, borderBottomColor = props.borderBottomColor, borderRightColor = props.borderRightColor, parentBorderTopWidth = props.parentBorderTopWidth, parentBorderLeftWidth = props.parentBorderLeftWidth, parentBorderBottomWidth = props.parentBorderBottomWidth, parentBorderRightWidth = props.parentBorderRightWidth, parentBorderTopStyle = props.parentBorderTopStyle, parentBorderLeftStyle = props.parentBorderLeftStyle, parentBorderBottomStyle = props.parentBorderBottomStyle, parentBorderRightStyle = props.parentBorderRightStyle, parentBorderTopColor = props.parentBorderTopColor, parentBorderLeftColor = props.parentBorderLeftColor, parentBorderBottomColor = props.parentBorderBottomColor, parentBorderRightColor = props.parentBorderRightColor, borderRadius = props.borderRadius, borderLeftBeforeTopRadius = props.borderLeftBeforeTopRadius, borderRightBeforeTopRadius = props.borderRightBeforeTopRadius, borderLeftBeforeBottomRadius = props.borderLeftBeforeBottomRadius, borderRightBeforeBottomRadius = props.borderRightBeforeBottomRadius, borderTopRadius = props.borderTopRadius, borderRightRadius = props.borderRightRadius, borderBottomRadius = props.borderBottomRadius, borderLeftRadius = props.borderLeftRadius, borderTopLeftRadius = props.borderTopLeftRadius, borderTopRightRadius = props.borderTopRightRadius, borderBottomRightRadius = props.borderBottomRightRadius, borderBottomLeftRadius = props.borderBottomLeftRadius, borderCollapse = props.borderCollapse, borderSpacing = props.borderSpacing, hoverBackgroundColor = props.hoverBackgroundColor, flexBasis = props.flexBasis, flexGrow = props.flexGrow, flexShrink = props.flexShrink, lineFactor = props.lineFactor, widthLines = props.widthLines, animatedValues = props.animatedValues, onClick = props.onClick, children = props.children;
    var css = ouiStyle.useButtonStyle({
        fontSize: fontSize,
        fontWeight: fontWeight,
        color: color,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingHorizontal: paddingHorizontal,
        paddingVertical: paddingVertical,
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingBottom: paddingBottom,
        paddingRight: paddingRight,
        iconContainer: iconContainer,
        baselinePadding: baselinePadding,
        childPaddingTop: childPaddingTop,
        childPaddingLeft: childPaddingLeft,
        childPaddingBottom: childPaddingBottom,
        childPaddingRight: childPaddingRight,
        margin: margin,
        marginHorizontal: marginHorizontal,
        marginVertical: marginVertical,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft,
        borderStyle: borderStyle,
        borderHorizontalStyle: borderHorizontalStyle,
        borderVerticalStyle: borderVerticalStyle,
        borderTopStyle: borderTopStyle,
        borderLeftStyle: borderLeftStyle,
        borderBottomStyle: borderBottomStyle,
        borderRightStyle: borderRightStyle,
        borderWidth: borderWidth,
        borderHorizontalWidth: borderHorizontalWidth,
        borderVerticalWidth: borderVerticalWidth,
        borderTopWidth: borderTopWidth,
        borderLeftWidth: borderLeftWidth,
        borderBottomWidth: borderBottomWidth,
        borderRightWidth: borderRightWidth,
        borderColor: borderColor,
        borderHorizontalColor: borderHorizontalColor,
        borderVerticalColor: borderVerticalColor,
        borderTopColor: borderTopColor,
        borderLeftColor: borderLeftColor,
        borderBottomColor: borderBottomColor,
        borderRightColor: borderRightColor,
        parentBorderTopWidth: parentBorderTopWidth,
        parentBorderLeftWidth: parentBorderLeftWidth,
        parentBorderBottomWidth: parentBorderBottomWidth,
        parentBorderRightWidth: parentBorderRightWidth,
        parentBorderTopStyle: parentBorderTopStyle,
        parentBorderLeftStyle: parentBorderLeftStyle,
        parentBorderBottomStyle: parentBorderBottomStyle,
        parentBorderRightStyle: parentBorderRightStyle,
        parentBorderTopColor: parentBorderTopColor,
        parentBorderLeftColor: parentBorderLeftColor,
        parentBorderBottomColor: parentBorderBottomColor,
        parentBorderRightColor: parentBorderRightColor,
        borderRadius: borderRadius,
        borderLeftBeforeTopRadius: borderLeftBeforeTopRadius,
        borderRightBeforeTopRadius: borderRightBeforeTopRadius,
        borderLeftBeforeBottomRadius: borderLeftBeforeBottomRadius,
        borderRightBeforeBottomRadius: borderRightBeforeBottomRadius,
        borderTopRadius: borderTopRadius,
        borderRightRadius: borderRightRadius,
        borderBottomRadius: borderBottomRadius,
        borderLeftRadius: borderLeftRadius,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomRightRadius: borderBottomRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderCollapse: borderCollapse,
        borderSpacing: borderSpacing,
        hoverBackgroundColor: hoverBackgroundColor,
        flexBasis: flexBasis,
        flexGrow: flexGrow,
        flexShrink: flexShrink,
        lineFactor: lineFactor,
        widthLines: widthLines,
    });
    return (jsx(Link, { href: to, replace: replace, target: target, rel: rel, onClick: onClick, css: ouiStyle.mediaQuery(css), animatedValues: animatedValues },
        children,
        jsx(RampWithNameTransform, { rampName: "RippleEffect", sourceBackgroundColor: css.backgroundColor })));
};
